import React, { ChangeEvent } from 'react';
import styled from 'styled-components';

type TextFieldComponentProps = {
  type?: string
  id?: string
  className?: string
  label?: string
  name?: string
  placeholder?: string
  mb?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  value?: string | number
  required?: boolean
  autoFocus?: boolean
  readonly?: boolean
}

const TextFieldStyle = styled.div<{$mb?: string}>`
  position: relative;
  border: 1px solid rgb(219, 219, 219);
  border-radius: 25px;
  margin-bottom: ${props => props.$mb || '0'};
  height: 50px;
  width: 100%;

  label {
    position: absolute;
    background: white;
    color: #222;
    font-size: 12px;
    top: -10px;
    left: 14px;
    padding: 0 5px;
  }

  input {
    border: none;
    border-radius: 25px;
    box-sizing: border-box;
    color: #222;
    font-size: 16px;
    outline: none;
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
    height: 100%;
  }

  input[type="date"] {
    -webkit-appearance: none;
  }

  input[type="date"]::-webkit-date-and-time-value {
    text-align: left;
  }
`;

const TextField: React.FC<TextFieldComponentProps> = ({ type, id, className, label, name, placeholder, mb, onChange, value, required, autoFocus, readonly }) => {
  return (
    <TextFieldStyle className={className} $mb={mb}>
      { type !== 'number' && value && <label htmlFor={id}>{label}</label> }
      <input type={type} id={id} name={name} placeholder={placeholder} onChange={onChange} value={value} required={required} autoFocus={autoFocus} readOnly={readonly} />
    </TextFieldStyle>
  );
};

export default TextField;
